import { render, staticRenderFns } from "./voteChoiceQuestions.vue?vue&type=template&id=157667e8"
import script from "./voteChoiceQuestions.vue?vue&type=script&lang=js"
export * from "./voteChoiceQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports